var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 4,
    y: 18.5,
    width: 12,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.955 0l.297.005c3.167.12 5.788 2.656 5.842 5.655.036 1.987-1.012 3.838-2.76 4.917l-.222.131v.588h2.514c1.599 0 2.99 1.028 3.302 2.447a2.984 2.984 0 01-.66 2.608 3.341 3.341 0 01-2.337 1.143l-.211.006H4.28c-.991 0-1.92-.42-2.547-1.151a2.976 2.976 0 01-.661-2.604c.302-1.36 1.59-2.36 3.103-2.442l.2-.005h2.513v-.588C5.045 9.675 3.906 7.79 3.906 5.762c0-1.583.666-3.059 1.874-4.156C6.916.574 8.382.01 9.955 0zm-.017 1.5c-1.195.014-2.294.44-3.15 1.217-.897.815-1.382 1.89-1.382 3.045 0 1.476.839 2.867 2.217 3.64.43.242.71.677.758 1.162l.007.146v.588a1.5 1.5 0 01-1.355 1.493l-.145.007H4.374c-.919 0-1.68.564-1.838 1.273-.103.462.016.928.335 1.301.303.353.74.575 1.225.62L4.28 16h11.44a1.85 1.85 0 001.408-.625c.32-.373.439-.842.335-1.31-.145-.66-.825-1.198-1.667-1.263l-.17-.006h-2.514a1.5 1.5 0 01-1.494-1.356l-.006-.144v-.588a1.5 1.5 0 01.765-1.308c1.409-.791 2.245-2.205 2.217-3.714-.038-2.118-1.892-3.975-4.153-4.168l-.213-.013-.29-.005z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
export default SvgApproval;